import { AbstractControl } from '@angular/forms';
import { EventEmitter } from '@angular/core';

const MIN_ANGLE = 0;
const MAX_ANGLE = 360;

export const angleChanged = (control: AbstractControl, emitter: EventEmitter<number>): void => {
  if (!control) {
    return;
  }

  if (control.value < MIN_ANGLE) {
    control.setValue(MIN_ANGLE);
  }

  if (control.value > MAX_ANGLE) {
    control.setValue(MAX_ANGLE);
  }

  emitter.emit(Number(control.value));
};
